'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var modules_b3384f04 = {"container":"TableView_module_container__e9d0566f","table":"TableView_module_table__e9d0566f"};
require("../../../assets/cjs/components/Table/src/TableView~CkmL79_g.css");

exports.default = modules_b3384f04;
//# sourceMappingURL=TableView.module.less.js.map
